import Carousel from "../../component/carousel"
import News from "../../component/news"

const HeadBusinessOperation_Portugal = () => {
  return (
    <>
      {/* HERO / CAROUSEL */}
      <Carousel
        mainText={`We’re Hiring!`}
        smallText={`Head of Business Operation – Portugal`}
        images={["img/slide-01.jpg", "img/slide-01.jpg", "img/slide-01.jpg"]}
      />

      {/* INTRO */}
      <section className="mod-two-cols" data-lazy-load>
        <div className="">
          <div className="grid">
            <div className="grid__item md--two-thirds mod-two-cols--padded">
              <h3 className="heading-1">
                <span>Head of Business Operation – Portugal</span>
              </h3>

              <p
                style={{
                  fontSize: "20px",
                  lineHeight: "120%",
                  marginTop: "15px",
                }}
              >
                At <b>CIMGLOBAL</b>, we don’t just organise congresses—we create
                global platforms where industries connect, ideas are born, and
                meaningful progress takes shape. As trusted partners to leading
                associations and scientific societies worldwide, we transform
                vision into impactful, memorable experiences.
              </p>

              <p
                style={{
                  fontSize: "20px",
                  lineHeight: "120%",
                  marginTop: "10px",
                }}
              >
                As we expand our team in <b>Portugal</b>, we are seeking a
                senior-level business leader to drive market growth and
                represent CIMGLOBAL with excellence.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* YOUR MISSION */}
      <article
        className="mod-text-media mod-text-media__scheme--Light"
        data-lazy-load
      >
        <div className="mod-text-media__wrapper grid">
          <div className="grid lg--two-thirds md-one-whole mod-two-cols--padded">
            <div className="grid__item">
              <div className="mod-text__content">
                <h3 className="heading-3 mod-text__header mod-text-media__header">
                  Your Mission
                </h3>

                <p
                  style={{
                    fontSize: "20px",
                    lineHeight: "120%",
                    marginTop: "10px",
                  }}
                >
                  <b>Forge partnerships. Drive strategy.</b> Shape our success
                  in Portugal.
                </p>

                <p
                  style={{
                    fontSize: "20px",
                    lineHeight: "120%",
                    marginTop: "10px",
                  }}
                >
                  This is a strategic leadership position where you will
                  identify and secure national and international conference
                  mandates, nurture long-term partnerships, and position
                  CIMGLOBAL as the preferred PCO for associations and
                  institutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </article>

      {/* WHAT YOU WILL DO */}
      <article
        className="mod-text-media mod-text-media__scheme--Light"
        data-lazy-load
      >
        <div className="mod-text-media__wrapper grid">
          <div className="grid lg--two-thirds md-one-whole mod-two-cols--padded">
            <div className="grid__item">
              <div className="mod-text__content">
                <h3 className="heading-3 mod-text__header mod-text-media__header">
                  What You Will Do
                </h3>

                <ul
                  style={{
                    listStyle: "disc",
                    marginLeft: "25px",
                    fontSize: "20px",
                    lineHeight: "120%",
                    marginTop: "5px",
                  }}
                >
                  <li>
                    <b>Be a Strategic Partner:</b> Engage association leaders to
                    understand their objectives and position CIMGLOBAL as a
                    long-term collaborator.
                  </li>
                  <li>
                    <b>Lead the Bid Process:</b> Manage proposal development,
                    bid strategy, and contract negotiations for major events.
                  </li>
                  <li>
                    <b>Grow Our Ecosystem:</b> Build strong relationships with
                    convention bureaus, venues, tourism bodies, and industry
                    partners in Portugal and internationally.
                  </li>
                  <li>
                    <b>Represent the Brand:</b> Attend key industry events as a
                    CIMGLOBAL ambassador to strengthen presence and uncover
                    opportunities.
                  </li>
                  <li>
                    <b>Drive Commercial Success:</b> Take ownership of portfolio
                    growth, profitability, and pipeline development.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </article>

      {/* WHAT WE’RE LOOKING FOR */}
      <article
        className="mod-text-media mod-text-media__scheme--Light"
        data-lazy-load
      >
        <div className="mod-text-media__wrapper grid">
          <div className="grid lg--two-thirds md-one-whole mod-two-cols--padded">
            <div className="grid__item">
              <div className="mod-text__content">
                <h3 className="heading-3 mod-text__header mod-text-media__header">
                  What We’re Looking For
                </h3>

                <ul
                  style={{
                    listStyle: "disc",
                    marginLeft: "25px",
                    fontSize: "20px",
                    lineHeight: "120%",
                    marginTop: "5px",
                  }}
                >
                  <li>
                    10+ years of experience leading a profit centre within the
                    MICE, PCO, DMC, or event industry.
                  </li>
                  <li>
                    Proven success in winning new business and achieving
                    revenue targets.
                  </li>
                  <li>
                    Strong consultative sales skills and long-term relationship
                    building ability.
                  </li>
                  <li>
                    Commercial acumen, including pricing, budgeting, and P&L
                    management.
                  </li>
                  <li>
                    Excellent communication and presentation skills with senior
                    stakeholders.
                  </li>
                  <li>
                    A proactive, visionary mindset focused on opportunity
                    creation and results.
                  </li>
                  <li>
                    <b>Native or fluent Portuguese</b> and <b>fluent English</b>{" "}
                    are essential.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </article>

      {/* WHY CIMGLOBAL */}
      <article
        className="mod-text-media mod-text-media__scheme--Light"
        data-lazy-load
      >
        <div className="mod-text-media__wrapper grid">
          <div className="grid lg--two-thirds md-one-whole mod-two-cols--padded">
            <div className="grid__item">
              <div className="mod-text__content">
                <h3 className="heading-3 mod-text__header mod-text-media__header">
                  Why Join CIMGLOBAL?
                </h3>

                <ul
                  style={{
                    listStyle: "disc",
                    marginLeft: "25px",
                    fontSize: "20px",
                    lineHeight: "120%",
                    marginTop: "5px",
                  }}
                >
                  <li>
                    <b>Make a Real Impact:</b> Take ownership of the Portuguese
                    market with autonomy and clear growth opportunities.
                  </li>
                  <li>
                    <b>Be Part of a Global Leader:</b> Join an international PCO
                    with nearly 30 years of global experience.
                  </li>
                  <li>
                    <b>Grow with Us:</b> This role is central to our expansion
                    strategy and offers significant career advancement.
                  </li>
                  <li>
                    <b>Supportive Team:</b> Access global resources, proposal
                    teams, and senior leadership support.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </article>

      {/* HOW TO APPLY */}
      <article
        className="mod-text-media mod-text-media__scheme--Light"
        data-lazy-load
      >
        <div className="mod-text-media__wrapper grid">
          <div className="grid lg--two-thirds md-one-whole mod-two-cols--padded">
            <div className="grid__item">
              <div className="mod-text__content">
                <h3 className="heading-3 mod-text__header mod-text-media__header">
                  How to Apply
                </h3>

                <p
                  style={{
                    fontSize: "20px",
                    lineHeight: "120%",
                    marginTop: "15px",
                  }}
                >
                  If you are a relationship-builder and strategic leader ready
                  to create something remarkable in Portugal, we would love to
                  hear from you.
                </p>

                <p
                  style={{
                    fontSize: "20px",
                    lineHeight: "120%",
                    marginTop: "10px",
                  }}
                >
                  Send your CV and a brief cover letter outlining a recent
                  achievement to:{" "}
                  <a href="mailto:info.portugal@cimglobal.net">
                    <b>
                      <u>info.portugal@cimglobal.net</u>
                    </b>
                  </a>
                  <br></br><br></br>
<a class="link link--pointing dot__wrapper mod-related__block link--zoom-image" href="./docs/Head-of-Business-Operation-Portuga_PT.pdf" target="_blank" title="Read more" rel="noopener" className="link--pointing link--pill ">Read in Portuguese</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </article>

      <News />
    </>
  )
}

export default HeadBusinessOperation_Portugal
